package com.wintermar.inspection.feature.presentation.template.landing.widget

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.widget.table_container.HeaderTableContainer
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.last_updated_letter_case
import inspection.composeapp.generated.resources.status
import inspection.composeapp.generated.resources.template
import org.jetbrains.compose.resources.stringResource

@Composable
fun TemplateLandingHeader() {
    HeaderTableContainer(
        items = listOf(
            stringResource(Res.string.template),
            stringResource(Res.string.last_updated_letter_case),
            stringResource(Res.string.status),
        ),
        widthItems = listOf(1f, 0.5f, 0.5f)
    )
}
